// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231213/js/" + chunkId + "." + {"44":"bf6827d2","225":"6a10d214","481":"276626e4","486":"5deeec67","770":"7bc5b401"}[chunkId] + ".0.16668067530507524.chunk.js";
};